import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { showCredentialDetail } from 'store/Credentials/actions';
import { Wrapper, CloseIconWrapper, CloseIcon, IconUser, TitleWrapper, Title } from './styled';

const Header = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <Wrapper>
      <TitleWrapper>
        <IconUser />
        <Title>{ intl.formatMessage({ id: 'credentials.detail.title' }) }</Title>
      </TitleWrapper>
      <CloseIconWrapper onClick={ () => dispatch(showCredentialDetail(false)) }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
